import React, { useState, useEffect, useMemo } from 'react';

import Autocomplete from '@material-ui/lab/Autocomplete';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import moment from 'moment';
import {
  FormControl,
  MenuItem,
  TextField,
  InputLabel,
  Select,
  InputAdornment,
} from '@material-ui/core';
import { wsGetAll, wsFindBy } from 'services/WService';
import ModalFilterBPartner from 'components/Tvendo/Common/ModalFilterBPartner';
import { Search } from '@material-ui/icons';
import RegularButton from 'components/CustomButtons/Button';
import MultiComplete from './MultiCompleteForFilter';

const itemsStates = [
  { value: 'D', text: 'Borrador' },
  { value: 'V', text: 'Validado' },
  { value: 'C', text: 'Confirmado' },
  { value: 'X', text: 'Pendiente Procesar' },
  { value: 'R', text: 'Recibido' },
  { value: 'A', text: 'Anulado' },
  { value: 'Y', text: 'Por contabilizar' },
  { value: 'T', text: 'Contabilizado' },
  { value: 'Z', text: 'Preparado para NC' },
  { value: 'E', text: 'Registrado NC' },
];

export default function FilterCustom(props) {
  const {
    disabled = false,
    getFilter,
    fullWidth, // ? opcional ancho al 100% para filtros
    periodoBimensual, // para periodo bimensual
    typePurchCreditNote, // para tipo de nota de credito (MERCARDERIA, SERVICIOS)
    typePurchCreditNoteSap, // para tipo de nota de credito SAP (VIGENTE, ANULADO SAP, ANULADO INTERNO)
    typeSoftys, // para tipo de softys (Cobertura, Ingreso por compras, Salida por ventas)
    typeBono, // para tipo de bonos (Supervisor, Vendedor)
    typeProveedor, // para tipo de proveedores (Proveedores en desarrollo, Proveedores principales)
    category, // para categorias
    date,
    dateWeek,
    labelDate, // ? opcional nombre de etiqueta para fecha
    dateType, // ? opcional tipo de input a evaluar para fecha
    dateField, // ? opcional nombre de campo a evaluar para fecha
    dateRange,
    diffRange = 0, // ? dias de diferencia para en rango de fechas
    dateRangeProg,
    zone,
    layer,
    zoneCode,
    GroupCommisisions,
    TypeWorker,
    warehouse, // !requerido mandar el tipo de almacén a listar (T = todos, M = malogrados, N = normales)
    provider,
    providerFiled, // ? opcional campo para evaluar proveedor
    family,
    product,
    customer,
    customerCardCode,
    mark,
    bureau,
    seller,
    sellerCode,
    allSeller,
    supervisor,
    supervisorH,
    allSupervisor,
    commissions,
    commissionField,
    jefe,
    canal,
    state,
    defaultState = undefined,
    nameState = 'state',
    stateMultiple,
    optionValues, // !requerido  valores del filtro estado
    nameOptions, // !requerido nombre de campos del filtro estado
    component, // ? opcional mostrar un componente consecuente de los fitlros
    defaultValues = undefined,
    customControl = undefined,
    buttonSearch = false,
  } = props;

  const [valueSearch, setValueSearch] = useState({
    [!!dateRangeProg ? 'filter_start_date' : 'start_date']: moment(
      /* !!dateRangeProg ? */ moment().subtract(diffRange, 'days') /* : undefined */,
    ).format('YYYY-MM-DD'),
    [!!dateRangeProg ? 'filter_end_date' : 'end_date']: moment().format('YYYY-MM-DD'),
    [!!dateField ? dateField : 'date']:
      date === 'empty'
        ? ''
        : moment().format(!!dateType && dateType === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD'),
    proc_status: ['D'],
    // Estado
    [nameState]: defaultState ? defaultState : '',
    // Valores por default
    ...defaultValues,
  });

  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [bPartnerSelect, setBPartnerSelect] = useState({}); // socio negocio seleccionado
  const [openModalBPartnerC, setOpenModalBPartnerC] = useState(false); //Abrir modal
  const [typeCommission, setTypeCommission] = useState({});
  const [fieldCom, setFieldCom] = useState({});
  const [processing, setProcessing] = useState(false);

  const handleChange = (e) => {
    setValueSearch({ ...valueSearch, [e.target.name]: e.target.value });
  };

  const [dayWeek, setDayWeeks] = useState([]);
  async function listDayWeeks() {
    let response = await wsGetAll('base/visit-week');
    if (response.success) setDayWeeks(response.data);
  }

  const [zones, setZones] = useState([]);
  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  const [layers, setLayers] = useState([]);
  const [selectedLayers, setSelectedLayers] = useState([]);
  async function listLayers() {
    let response = await wsGetAll('base/layer');
    if (response.success) setLayers(response.data);
  }

  const [groupC, setGroupC] = useState([]);
  async function listGroupCommissions() {
    let response = await wsGetAll('sale/grupo-comisiones');
    if (response.success) setGroupC(response.data);
  }

  const [typeW, setTypeW] = useState([]);
  async function listTypeWorkers() {
    let response = await wsGetAll('sale/tipo-trabajadores');
    if (response.success) setTypeW(response.data);
  }

  const [warehouses, setWarehouses] = useState([]);
  async function listWarehouses() {
    let filter = {};
    
    if (Array.isArray(warehouse)) {
      if (warehouse[0]) {
        filter.warehouse_type = warehouse[0];
      }
      if (warehouse[1]) {
        filter.typeDM = warehouse[1];
      }
    } else {
      filter.warehouse_type = warehouse;
      if (warehouse === 'T') delete filter.warehouse_type;
    }
    
    let response = await wsFindBy('logi/warehouse', filter);
    if (response.success) setWarehouses(response.data);
  }

  const [providers, setProviders] = useState([]);
  async function listProviders() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProviders(response.data);
  }
  const [customers, setCustomers] = useState([]);
  async function listCustomers() {
    let response = await wsFindBy('base/business-partner', { CardType: 'C', QryGroup1: 'N', deleted_at: null });
    if (response.success) setCustomers(response.data);
  }

  const [families, setFamilies] = useState([]);
  async function listFamilies() {
    let response = await wsFindBy('sale/cobertura-referencia-winter/list-family ');
    if (response.success) setFamilies(response.data);
  }

  const [products, setProducts] = useState([]);
  async function listProducts() {
    let response = await wsFindBy('sale/cobertura-referencia-winter/list-product ');
    if (response.success) setProducts(response.data);
  }
  
  const [periodBiMonth, setPeriodsBiMonths] = useState([]);
  async function listPeriodBiMonth() {
    let response = await wsGetAll('sale/cobertura-colgate ');
    if (response.success) setPeriodsBiMonths(response.data);
  }
  const listTypePurchCreditNote= [
    { label: 'Todos', value: '' }, 
    { label: 'Mercaderia', value: 'I' }, 
    { label: 'Servicio', value: 'S' }, 
  ];

  const listTypePurchCreditNoteSap= [
    { label: 'Todos', value: '' }, 
    { label: 'Vigente', value: 'V' }, 
    { label: 'Anulado SUNAT', value: 'A' }, 
    { label: 'Anulado interno', value: 'I' }
  ];

  const listTypesSoftys= [
    { label: 'Cobertura', value: 'C' }, 
    { label: 'Venta', value: 'O' }, 
    { label: 'Compra', value: 'I' }
  ];

  const listTypesBonos= [
    { label: 'Supervisor', value: 'SU' }, 
    { label: 'Vendedor', values: ['VE', 'SE'] },
  ];

  const listTypesProveedor= [
    { label: 'Proveedores en desarrollo', value: 'PD' }, 
    { label: 'Proveedores principales', value: 'PP' },
  ];

  const [marks, setMarks] = useState([]);
  async function listMarks() {
    let response = await wsGetAll('logi/mark');
    if (response.success) setMarks(response.data);
  }

  const [bureaus, setBureaus] = useState([]);
  async function listBureaus() {
    let response = await wsGetAll('base/bureau');
    if (response.success) setBureaus(response.data);
  }
  const filteredBureaus = useMemo(() => {
    if (valueSearch.base_zone_id === undefined) return bureaus;
    return bureaus.filter(
      (bureau) => parseInt(bureau.base_zone_id) === parseInt(valueSearch.base_zone_id),
    );
  }, [bureaus, valueSearch]);

  const [canals, setCanals] = useState([]);
  async function listCanals() {
    let response = await wsGetAll('base/canal');
    if (response.success) setCanals(response.data);
  }

  const [sellers, setSellers] = useState([]);
  async function listSellers(zoneId = undefined) {
    let entity = 'base/seller';
    if (!!zoneId) {
      entity += `?base_zone_id=${zoneId}`;
    }
    let response = await wsGetAll(entity);
    if (response.success) setSellers(response.data);
  }

  const [categories, setCategories] = useState([]);
  async function listCategories() {
    let response = await wsFindBy('logi/category', 'base_business_partner_id', 10);
    if (response.success) setCategories(response.data);
  }

  async function listSellersBureau() {
    let response = await wsGetAll('sale/seller-quote-winter/sellers-bureau');
    if (response.success) setSellers(response.data);
  }

  const [allSellers, setAllSellers] = useState([]);
  async function listAllSellers() {
    let response = await wsFindBy('base/seller', { base_business_partner_id: 7, state: 'A', deleted: 'null' });
    if (response.success) setAllSellers(response.data);
  }

  const [supervisores, setSupervisores] = useState([]);
  async function listSupervisores() {
    let response = await wsGetAll('base/supervisor');
    if (response.success) setSupervisores(response.data);
  }
  const [supervisoresH, setSupervisoresH] = useState([]);
  async function listSupervisoresH() {
    let response = await wsFindBy('base/supervisor', { state: 'A', deleted: 'null' });
    if (response.success) setSupervisoresH(response.data);
  }

  const [allSupervisores, setAllSupervisores] = useState([]);
  async function listAllSupervisores() {
    let response = await wsFindBy('base/all-supervisors');
    if (response.success) setAllSupervisores(response.data);
  }

  const [jefes, setJefes] = useState([]);
  async function listJefes(position) {
    let tipoJefe = position === 'M' ? 1 : position === 'R' ? 2 : 3;

    let response = undefined;
    if (tipoJefe > 0 && tipoJefe <= 2) {
      response = await wsFindBy('prog/distribution-staff', { base_employee_positon_id: tipoJefe });
    } else if (tipoJefe === 3) {
      //response = await wsGetAll('base/supervisor'); // TODO aun no se implementa
    }
    if (response?.success) setJefes(response.data);
  }

  useEffect(() => {
    if (dateWeek) {
      listDayWeeks();
    }
    if (zone) {
      listZones();
    }
    if (layer) {
      listLayers();
    }
    if (zoneCode) {
      listZones();
    }
    if (GroupCommisisions) {
      listGroupCommissions();
    }
    if (TypeWorker) {
      listTypeWorkers();
    }
    if (warehouse) {
      listWarehouses();
    }
    if (provider) {
      listProviders();
    }
    if (customerCardCode) {
      listCustomers();
    }
    if (family) {
      listFamilies();
    }
    if (product) {
      listProducts();
    }
    if (periodoBimensual) {
      listPeriodBiMonth();
    }
    if (category) {
      listCategories();
    }
    if (mark) {
      listMarks();
    }
    if(canal) {
      listCanals();
    }
    if (seller) {
      if (zone === undefined) {
        listSellers();
      }
    }
    if (sellerCode) {
      if (zone === undefined) {
        listSellersBureau();
      }
    }
    if (allSeller) {
      listAllSellers();
    }
    if(supervisor) {
      listSupervisores();
    }
    if(supervisorH) {
      listSupervisoresH();
    }
    if(allSupervisor) {
      listAllSupervisores();
    }
    if (bureau) listBureaus();
    
    if (!date) {
      delete valueSearch[!!dateField ? dateField : 'date'];
    }
    if (!dateRange) {
      delete valueSearch.start_date;
      delete valueSearch.end_date;
    }
    if (!stateMultiple) {
      delete valueSearch.proc_status;
    }
    /* getFilter(valueSearch); */
  }, []);

  useEffect(() => {
    if (seller) {
      listSellers(valueSearch.base_zone_id);
    }
  }, [valueSearch.base_zone_id]);

  useEffect(() => {
    if (bPartnerSelect.id) {
      getFilter({ base_business_partner_id: bPartnerSelect.id, ...valueSearch });
      setValueSearch({ base_business_partner_id: bPartnerSelect.id, ...valueSearch });
    }
  }, [bPartnerSelect]);

  // useEffect(() => {
  //   if (bPartnerSelectC.CardCode) {
  //     getFilter({ CardCode: bPartnerSelectC.CardCode, ...valueSearch });
  //     setValueSearch({ CardCode: bPartnerSelectC.CardCode, ...valueSearch });
  //   }
  // }, [bPartnerSelectC]);

  async function startSearch() {
    setProcessing(true);
    if (props.getValueSearch) {
      await props.getValueSearch(valueSearch);
    }
    if (getFilter) {
      for (let clave in valueSearch) {
        if (
          valueSearch[clave] == null ||
          valueSearch[clave] == undefined ||
          valueSearch[clave] == ''
        ) {
          delete valueSearch[clave]; //eliminamos las claves nulas
        }
      }
      await getFilter(valueSearch);
    }
    setProcessing(false);
  }

  useEffect(() => {
    if (buttonSearch === true) return;
    startSearch();
  }, [valueSearch, buttonSearch]);

  useEffect(() => {
    if (!!typeCommission.key) {
      listJefes(typeCommission.key);
      setFieldCom(typeCommission.key === 'S' ? 'base_supervisor_id' : 'prog_distribution_staff_id');
    }
  }, [typeCommission]);

  return (
    <>
      {openModalBPartner ? (
        <ModalFilterBPartner
          open={openModalBPartner}
          setOpen={setOpenModalBPartner}
          cardType="C"
          entity="base/business-partner"
          setBPartnerSelect={setBPartnerSelect}
        />
      ) : undefined}

      <GridContainer>
        {props.children}

        {!!date ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2} /* key={!!dateType ? dateType : null} */
          >
            <TextField
              key={date}
              disabled={disabled}
              label={!!labelDate ? labelDate : 'Fecha'}
              fullWidth
              type={!!dateType ? dateType : 'date'}
              margin="normal"
              name={!!dateField ? dateField : 'date'}
              value={
                !valueSearch[!!dateField ? dateField : 'date']
                  ? ''
                  : moment(valueSearch[!!dateField ? dateField : 'date']).format(
                      dateType === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD',
                    )
              }
              onChange={(e) => {
                handleChange(e);
                delete valueSearch[!!dateField ? dateField : 'date'];
              }}
              InputLabelProps={{ shrink: true }}
              inputProps={{ max: moment().format('YYYY-MM-DD') }}
            />
          </GridItem>
        ) : undefined}

        {!!dateRange || !!dateRangeProg ? (
          <>
            <GridItem
              xs={12}
              md={!!fullWidth ? 12 : 4}
              lg={!!fullWidth ? 12 : 3}
              xl={!!fullWidth ? 12 : 2}
            >
              <TextField
                label="Desde"
                disabled={disabled}
                fullWidth
                type="date"
                margin="normal"
                name={!!dateRangeProg ? 'filter_start_date' : 'start_date'}
                value={
                  valueSearch[!!dateRangeProg ? 'filter_start_date' : 'start_date'] ||
                  moment().format('YYYY-MM-DD')
                }
                onChange={(e) => {
                  handleChange(e);
                  delete valueSearch[!!dateRangeProg ? 'filter_start_date' : 'start_date'];
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ max: valueSearch[!!dateRangeProg ? 'filter_end_date' : 'end_date'] }}
              />
            </GridItem>
            <GridItem
              xs={12}
              md={!!fullWidth ? 12 : 4}
              lg={!!fullWidth ? 12 : 3}
              xl={!!fullWidth ? 12 : 2}
            >
              <TextField
                disabled={disabled}
                label="Hasta"
                fullWidth
                type="date"
                margin="normal"
                name={!!dateRangeProg ? 'filter_end_date' : 'end_date'}
                value={
                  valueSearch[!!dateRangeProg ? 'filter_end_date' : 'end_date'] ||
                  moment().format('YYYY-MM-DD')
                }
                onChange={(e) => {
                  handleChange(e);
                  delete valueSearch[!!dateRangeProg ? 'filter_end_date' : 'end_date'];
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: valueSearch[!!dateRangeProg ? 'filter_start_date' : 'start_date'],
                }}
              />
            </GridItem>
          </>
        ) : undefined}

        {!!dateWeek ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={dayWeek}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Días Visita" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch['base_visit_day_id'];
                  return setValueSearch({ ...valueSearch, base_visit_day_id: item.id });
                }
                delete valueSearch['base_visit_day_id'];
                setValueSearch({ ...valueSearch, base_visit_day_id: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!zone ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={zones}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Zona" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch['base_zone_id'];
                  return setValueSearch({ ...valueSearch, base_zone_id: item.id });
                }
                delete valueSearch['base_zone_id'];
                setValueSearch({ ...valueSearch, base_zone_id: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!layer ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <MultiComplete
              label="Capas"
              textField="name"
              selectAll
              limitTags={1}
              options={layers}
              selected={selectedLayers}
              setSelected={setSelectedLayers}
              onSelectionChange={(newSelected) => {
                delete valueSearch['base_layer_id'];
                setValueSearch({
                  ...valueSearch,
                  base_layer_id: newSelected.map(z => z.id),
                });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!zoneCode ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={zones}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Zona" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch['zone_code'];
                  return setValueSearch({ ...valueSearch, zone_code: item.code });
                }
                delete valueSearch['zone_code'];
                setValueSearch({ ...valueSearch, zone_code: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!GroupCommisisions ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={groupC}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Grupo Comisiones" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch['grupo_d_description'];
                  return setValueSearch({ ...valueSearch, grupo_d_description: item.description });
                }
                delete valueSearch['grupo_d_description'];
                setValueSearch({ ...valueSearch, grupo_d_description: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!TypeWorker ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={typeW}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Tipo de trabajador" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch['type_worker_code'];
                  return setValueSearch({ ...valueSearch, type_worker_code: item.code });
                }
                delete valueSearch['type_worker_code'];
                setValueSearch({ ...valueSearch, type_worker_code: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!warehouse ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={warehouses}
              getOptionLabel={(option) => option.WhsName}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Almacén" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.logi_warehouse_id;
                  return setValueSearch({ ...valueSearch, logi_warehouse_id: item.id });
                }
                delete valueSearch.logi_warehouse_id;
                setValueSearch({ ...valueSearch, logi_warehouse_id: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!family ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={families}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Familia" margin="normal" />}
              onChange={(e) => {
                if (e.target.value === '') {
                  delete valueSearch['id'];
                  setValueSearch({ id: null, ...valueSearch });
                }
              }}
            />
          </GridItem>
        ) : undefined}

        {!!product ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={products}
              getOptionLabel={(option) => option.ItemName}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Producto" margin="normal" />}
              onChange={(e) => {
                if (e.target.value === '') {
                  delete valueSearch['ItemCode'];
                  setValueSearch({ ItemCode: null, ...valueSearch });
                }
              }}
            />
          </GridItem>
        ) : undefined}

        {!!periodoBimensual ? (
          <GridItem
            xs={25}
            md={!!fullWidth ? 25 : 4}
            lg={!!fullWidth ? 25 : 3}
            xl={!!fullWidth ? 25 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={periodBiMonth}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Periodo Bi-Mensual" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.id_cobertura;
                  return setValueSearch({ ...valueSearch, id_cobertura: item.id });
                }
                delete valueSearch.id_cobertura;
                setValueSearch({ ...valueSearch, id_cobertura: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!typePurchCreditNote ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={listTypePurchCreditNote}
              getOptionLabel={(option) => option.label}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Tipo de nota de credito" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.DocType;
                  return setValueSearch({ ...valueSearch, DocType: item.value });
                }
                delete valueSearch.DocType;
                setValueSearch({ ...valueSearch, DocType: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!typePurchCreditNoteSap ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={listTypePurchCreditNoteSap}
              getOptionLabel={(option) => option.label}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Estado de nota de credito del sap" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.u_syp_status;
                  return setValueSearch({ ...valueSearch, u_syp_status: item.value });
                }
                delete valueSearch.u_syp_status;
                setValueSearch({ ...valueSearch, u_syp_status: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!typeSoftys ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={listTypesSoftys}
              getOptionLabel={(option) => option.label}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Tipo" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.tipo;
                  return setValueSearch({ ...valueSearch, tipo: item.value });
                }
                delete valueSearch.tipo;
                setValueSearch({ ...valueSearch, tipo: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!typeBono ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={listTypesBonos}
              getOptionLabel={(option) => option.label}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Tipo" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.type;
                  return setValueSearch({ ...valueSearch, type: item.value });
                }
                delete valueSearch.type;
                setValueSearch({ ...valueSearch, type: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!typeProveedor ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={listTypesProveedor}
              getOptionLabel={(option) => option.label}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Tipo" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.tipo;
                  return setValueSearch({ ...valueSearch, tipo: item.value });
                }
                delete valueSearch.tipo;
                setValueSearch({ ...valueSearch, tipo: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!category ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={categories}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Categorias" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.codigo_categoria;
                  return setValueSearch({ ...valueSearch, codigo_categoria: item.code });
                }
                delete valueSearch.codigo_categoria;
                setValueSearch({ ...valueSearch, codigo_categoria: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!provider ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={providers}
              getOptionLabel={(option) => option.CardName}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Proveedor" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch[!!providerFiled ? providerFiled : 'base_business_partner_id'];
                  if (!!props.getProvider) {
                    props.getProvider(item);
                  }
                  return setValueSearch({
                    ...valueSearch,
                    [!!providerFiled ? providerFiled : 'base_business_partner_id']: item.id,
                  });
                }
                delete valueSearch[!!providerFiled ? providerFiled : 'base_business_partner_id'];
                setValueSearch({
                  ...valueSearch,
                  [!!providerFiled ? providerFiled : 'base_business_partner_id']: null,
                });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!customer ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <TextField
              disabled={disabled}
              key={openModalBPartner}
              label="Cliente"
              type="search"
              value={bPartnerSelect?.CardName || ''}
              margin="normal"
              onKeyDown={() => false}
              onChange={(e) => {
                if (e.target.value === '') {
                  delete valueSearch['base_business_partner_id'];
                  setBPartnerSelect({});
                  setValueSearch({ base_business_partner_id: null, ...valueSearch });
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    style={{ cursor: 'pointer', color: '#07c107' }}
                    onClick={() => setOpenModalBPartner(true)}
                    position="start"
                  >
                    <Search />
                  </InputAdornment>
                ),
              }}
              fullWidth
            />
          </GridItem>
        ) : undefined}

        {!!mark ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={marks}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Marca" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.logi_mark_id;
                  return setValueSearch({ ...valueSearch, logi_mark_id: item.id });
                }
                delete valueSearch.logi_mark_id;
                setValueSearch({ ...valueSearch, logi_mark_id: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!bureau ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={filteredBureaus}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Mesa" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.base_bureau_id;
                  return setValueSearch({ ...valueSearch, base_bureau_id: item.id });
                }
                delete valueSearch.base_bureau_id;
                setValueSearch({ ...valueSearch, base_bureau_id: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {canal !== undefined && (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={canals}
              getOptionLabel={(option) => option.description}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Canal" margin="normal" />}
              onChange={(_, item) => {
                if (!!item) {
                  delete valueSearch.base_canal_id;
                  return setValueSearch({ ...valueSearch, base_canal_id: item.id });
                }
                delete valueSearch.base_canal_id;
                setValueSearch({ ...valueSearch, base_canal_id: null });
              }}
            />
          </GridItem>
        )}

        {!!seller ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={sellers}
              getOptionLabel={(option) => option.SlpName}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Vendedor" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.base_seller_id;
                  return setValueSearch({ ...valueSearch, base_seller_id: item.id });
                }
                delete valueSearch.base_seller_id;
                setValueSearch({ ...valueSearch, base_seller_id: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!sellerCode ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={sellers}
              getOptionLabel={(option) => `${option.SlpName} (Código: ${option.SlpCode})`}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Vendedor" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.SlpCode;
                  return setValueSearch({ ...valueSearch, SlpCode: item.SlpCode });
                }
                delete valueSearch.SlpCode;
                setValueSearch({ ...valueSearch, SlpCode: null });
              }}
            />
          </GridItem>
        ) : undefined}
        
        {!!allSeller ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={allSellers}
              getOptionLabel={(option) => `Código: ${option.SlpCode} - ${option.SlpName}`}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Vendedores" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.SlpCode;
                  return setValueSearch({ ...valueSearch, SlpCode: item.SlpCode });
                }
                delete valueSearch.SlpCode;
                setValueSearch({ ...valueSearch, SlpCode: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!supervisor ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              options={supervisores}
              getOptionLabel={(option) => option.name}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Supervisores" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.NombreVendedor;
                  return setValueSearch({ ...valueSearch, NombreVendedor: item.name });
                }
                delete valueSearch.NombreVendedor;
                setValueSearch({ ...valueSearch, NombreVendedor: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!supervisorH ? (
          <GridItem
            xs={15}
            md={!!fullWidth ? 15 : 5}
            lg={!!fullWidth ? 15 : 4}
            xl={!!fullWidth ? 15 : 3}
          >
            <Autocomplete
              disabled={disabled}
              options={supervisoresH}
              getOptionLabel={(option) => option.name}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Supervisores" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.supervisor;
                  return setValueSearch({ ...valueSearch, supervisor: item.name });
                }
                delete valueSearch.supervisor;
                setValueSearch({ ...valueSearch, supervisor: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!allSupervisor ? (
          <GridItem
            xs={15}
            md={!!fullWidth ? 15 : 5}
            lg={!!fullWidth ? 15 : 4}
            xl={!!fullWidth ? 15 : 3}
          >
            <Autocomplete
              disabled={disabled}
              options={allSupervisores}
              getOptionLabel={(option) => option.name}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Supervisores" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.supervisor;
                  return setValueSearch({ ...valueSearch, supervisor: item.name });
                }
                delete valueSearch.supervisor;
                setValueSearch({ ...valueSearch, supervisor: null });
              }}
            />
          </GridItem>
        ) : undefined}
        
        {!!customerCardCode ? (
          <GridItem
            xs={15}
            md={!!fullWidth ? 15 : 5}
            lg={!!fullWidth ? 15 : 4}
            xl={!!fullWidth ? 15 : 3}
          >
            <Autocomplete
              disabled={disabled}
              options={customers}
              getOptionLabel={(option) => option.CardName}
              defaultValue={undefined}
              renderInput={(params) => <TextField {...params} label="Clientes" margin="normal" />}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch.CardCode;
                  return setValueSearch({ ...valueSearch, CardCode: item.CardCode });
                }
                delete valueSearch.CardCode;
                setValueSearch({ ...valueSearch, CardCode: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!commissions ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <FormControl fullWidth margin="normal">
              <InputLabel>Tipo comisión</InputLabel>
              <Select
                disabled={disabled}
                defaultValue=""
                inputProps={{ name: commissionField }}
                onChange={(e) => {
                  handleChange(e);
                  delete valueSearch[commissionField];
                }}
              >
                <MenuItem
                  value=""
                  onClick={() => {
                    setTypeCommission({});
                    delete valueSearch[commissionField];
                    delete valueSearch[fieldCom];
                    setValueSearch({ ...valueSearch, [commissionField]: null, [fieldCom]: null });
                  }}
                >
                  Todos
                </MenuItem>
                {commissions.map((item, i) => (
                  <MenuItem
                    key={i}
                    value={item.key}
                    onClick={() => {
                      //TODO quitar este IF si llega a implementar supervisor
                      if (item.key === 'S') {
                        setTypeCommission({});
                        delete valueSearch[commissionField];
                        delete valueSearch[fieldCom];
                        setValueSearch({
                          ...valueSearch,
                          [commissionField]: null,
                          [fieldCom]: null,
                        });
                      } else {
                        setTypeCommission(item);
                      }
                    }}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </GridItem>
        ) : undefined}

        {!!jefe && (typeCommission?.key == 'R' || typeCommission?.key == 'M') ? ( //TODO, quitar (typeCommission.key !== 'S') si llega a implementar supervisor
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <Autocomplete
              disabled={disabled}
              key={typeCommission.key}
              options={jefes}
              getOptionLabel={(option) => option.name}
              defaultValue={undefined}
              renderInput={(params) => (
                <TextField {...params} label={typeCommission.label} margin="normal" />
              )}
              onChange={(e, item) => {
                if (!!item) {
                  delete valueSearch[fieldCom];
                  return setValueSearch({ ...valueSearch, [fieldCom]: item.id });
                }
                delete valueSearch[fieldCom];
                setValueSearch({ ...valueSearch, [fieldCom]: null });
              }}
            />
          </GridItem>
        ) : undefined}

        {!!component ? component : undefined}

        {!!stateMultiple ? (
          <GridItem md={props.fullWidth ? 12 : 4} xs={12}>
            <Autocomplete
              disabled={disabled}
              multiple
              size="small"
              margin="normal"
              options={itemsStates}
              disableCloseOnSelect={true}
              defaultValue={[itemsStates[0]] || ''}
              getOptionLabel={(item) => item.text}
              renderInput={(params) => (
                <TextField {...params} margin="normal" label="Filtro estados" required />
              )}
              onChange={(e, items) => {
                if (items?.length > 0) {
                  delete valueSearch.proc_status;
                  setValueSearch({
                    ...valueSearch,
                    proc_status: items?.map((item) => item.value),
                  });
                } else {
                  delete valueSearch.proc_status;
                  setValueSearch({ ...valueSearch, proc_status: null });
                }
              }}
            />
          </GridItem>
        ) : undefined}

        {!!state ? (
          <GridItem
            xs={12}
            md={!!fullWidth ? 12 : 4}
            lg={!!fullWidth ? 12 : 3}
            xl={!!fullWidth ? 12 : 2}
          >
            <FormControl fullWidth margin="normal">
              <InputLabel>Estado</InputLabel>
              <Select
                disabled={disabled}
                value={valueSearch[nameState] || ''}
                inputProps={{
                  name: nameState,
                }}
                onChange={(e) => {
                  handleChange(e);
                  delete valueSearch[nameState];
                }}
              >
                {optionValues?.map((item, i) => {
                  return (
                    <MenuItem key={i} value={item}>
                      {nameOptions[i]}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </GridItem>
        ) : undefined}

        {buttonSearch === true && (
          <RegularButton justIcon round color="success" onClick={startSearch} disabled={processing}>
            <Search />
          </RegularButton>
        )}

        {customControl !== undefined && customControl}
      </GridContainer>
    </>
  );
}
